/**
 * Registro del Service Worker (public/sw.js).
 *
 * Imprescindible: sin un registro, `navigator.serviceWorker.ready` NO resuelve
 * nunca, lo que dejaba el botón de activar push girando indefinidamente en
 * dispositivos donde el SW aún no estaba registrado. Registramos una sola vez
 * (idempotente) y devolvemos la registration ya activa.
 */

let readyPromise: Promise<ServiceWorkerRegistration> | null = null;

export function ensureServiceWorker(): Promise<ServiceWorkerRegistration> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return Promise.reject(new Error('Service worker not supported'));
  }
  if (!readyPromise) {
    readyPromise = navigator.serviceWorker
      .register('/sw.js')
      .then(() => navigator.serviceWorker.ready)
      .catch((err) => {
        // Permite reintentar en la próxima llamada si el registro falla.
        readyPromise = null;
        throw err;
      });
  }
  return readyPromise;
}
